import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/material.css";

const PhoneInputGroup = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
}) => {
  return (
    <div style={{ marginBottom: "1rem" }}>
      {/* {label && (
        <label style={{ display: "block", marginBottom: 4 }}>{label}</label>
      )} */}
      <PhoneInput
        placeholder="Enter phone number"
        label={label}
        country={"in"}
        autoFormat={false}
        value={value}
        onChange={(phone) => onChange(name)(phone)}
        onBlur={onBlur}
        inputStyle={{ width: "100%" }}
        inputProps={{ name }}
      />
      {touched && error && (
        <div style={{ color: "red", fontSize: "0.8rem", marginTop: 4 }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default PhoneInputGroup;
